import React from "react";
import { Box, Typography } from "@mui/material";
import TroisBarres from "./TroisBarres";
import BoutonAide from "./BoutonAide";

/* Titre de section : les trois barres devant, Montserrat, aide facultative,
   action facultative à droite. */
export default function TitreSection({ titre, aide, action, sousTitre }: {
  titre: string; aide?: string; action?: React.ReactNode; sousTitre?: string;
}) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 1.5, flexWrap: "wrap" }}>
      <TroisBarres taille="s" />
      <Typography component="h2" sx={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 17, color: "var(--c-text-primary)", lineHeight: 1.2 }}>
        {titre}
      </Typography>
      {aide && <BoutonAide texte={aide} />}
      {sousTitre && (
        <Typography sx={{ fontSize: 13, color: "var(--c-text-secondary)", ml: 0.5 }}>{sousTitre}</Typography>
      )}
      {action && <Box sx={{ ml: "auto" }}>{action}</Box>}
    </Box>
  );
}
